import { useState } from "react";

import { withEventTargetValue } from "neetocommons/utils/general";
import { Input } from "neetoui";
import { useTranslation } from "react-i18next";

import DynamicVariables from "components/DynamicVariables";

const SubjectField = ({
  name,
  text,
  updateText,
  subjectVariables = [],
  error,
  required = false,
  onBlur,
}) => {
  const [isFieldFocusedOnce, setIsFieldFocusedOnce] = useState(false);

  const { t } = useTranslation();

  const tagClickHandler = ({ key: slug, category }) => {
    const textAreaElement = document.querySelector(`textarea[name=${name}]`);
    const splitIndex =
      isFieldFocusedOnce && textAreaElement
        ? textAreaElement.selectionEnd
        : text.length;

    const variable = category ? `${category}.${slug}` : slug;
    const updatedSubject = [
      text.slice(0, splitIndex),
      ` {{${variable}}}`,
      text.slice(splitIndex),
    ].join("");
    updateText(updatedSubject);
  };

  return (
    <Input
      {...{ error, name, onBlur, required }}
      nakedInput
      label={t("neetoMolecules.emailForm.labels.subject")}
      placeholder={t("neetoMolecules.emailForm.placeholders.subject")}
      value={text}
      suffix={
        <DynamicVariables
          buttonProps={{ className: "m-1" }}
          variables={subjectVariables}
          dropdownProps={{
            className: "neeto-ui-dropdown__popup overflow-y-auto",
            buttonSize: "small",
          }}
          onVariableClick={tagClickHandler}
        />
      }
      onChange={withEventTargetValue(updateText)}
      onFocus={() => setIsFieldFocusedOnce(true)}
    />
  );
};

export default SubjectField;
